<template>
    <div class="flex flex-col h-full dark:bg-gray-600 gap-5">
        <div
            ref="scrollContainer"
            class="grid md:grid-cols-2 sm:grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 gap-6 overflow-auto p-5 pb-20"
        >
            <TestimonialItem v-for="item in testimonialList" :key="item.id" :testimonial="item"></TestimonialItem>
        </div>
    </div>
</template>

<script setup>
import { ref, inject, onMounted, onUnmounted } from "vue";
import TestimonialItem from "./TestimonialItem.vue";
import emitter from "@/boot/eventBus";
import debounce from "lodash/debounce";
import { Events } from "@/core/enums/EventsEnum";

const testimonialService = inject("testimonialService");
const testimonialList = ref([]);
const scrollContainer = ref();

let currentPage = 1;
let totalPages = 0;
let searchTerm = "";
let lastScrollTop = 0;

onMounted(() => {
    emitter.on(Events.aiTestimonialSearch, vectorSearchEvent);
    emitter.on(Events.testimonialSearch, paginatedSearchEvent);
    emitter.on(Events.testimonialUpdated, refreshTestimonial);
    emitter.on(Events.testimonialRemove, removeTestimonial);

    scrollContainer.value.addEventListener("scroll", () => {
        const container = scrollContainer.value;

        const scrollTop = container.scrollTop;
        const scrollHeight = container.scrollHeight;
        const offsetHeight = container.offsetHeight;

        if (scrollTop > lastScrollTop) {
            if (scrollTop + offsetHeight >= scrollHeight - 20) {
                nextPage();
            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
});

const nextPage = debounce(async () => {
    try {
        if (currentPage < totalPages) {
            currentPage++;
            if (searchTerm) {
                await aiSearchTestimonials();
                return;
            }
            getTestimonials();
        }
    } catch (error) {}
}, 500);

const getTestimonials = async () => {
    try {
        const response = await testimonialService.paginatedSearch(currentPage);
        testimonialList.value.push(...response.data);

        totalPages = response.totalPages;
    } catch {}
};

onUnmounted(() => {
    emitter.off(Events.aiTestimonialSearch);
    emitter.off(Events.testimonialSearch);
    emitter.off(Events.testimonialUpdated);
    emitter.off(Events.testimonialRemove);
});

const paginatedSearchEvent = async (data) => {
    currentPage = 1;
    testimonialList.value = [];
    searchTerm = "";

    await getTestimonials();
};

const vectorSearchEvent = async (data) => {
    currentPage = 1;
    testimonialList.value = [];
    searchTerm = data.searchTerm;

    await aiSearchTestimonials();
};

const aiSearchTestimonials = async () => {
    const response = await testimonialService.aiSearch(searchTerm, currentPage);
    testimonialList.value.push(...response.data);
    totalPages = response.totalPages;
};

const refreshTestimonial = async (data) => {
    const response = await testimonialService.getDetails(data.id);

    const index = testimonialList.value.findIndex((testimonial) => testimonial.id === data.id);

    if (index !== -1) {
        testimonialList.value[index] = response;
    }
};

const removeTestimonial = async (data) => {
    const index = testimonialList.value.findIndex((testimonial) => testimonial.id === data.id);

    if (index !== -1) {
        testimonialList.value.splice(index, 1);
    }
};
</script>

<style scoped></style>
